// extracted by mini-css-extract-plugin
export default {"formContainer":"UserCreate_formContainer__s3g47"};